import { Box, Container } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import products_mocs from "../__mocks__/budgets";
import { BudgetForm, BudgetRequestList } from "../components/budget";
import BudgetRequestListCanalDireto from "../components/requestControl/BudgetRequestListCanalDireto";
import BudgetRequestListToolbar from "../components/requestControl/BudgetRequestListToolbar";
import BudgetRequestListToolbarCanalDireto from "../components/requestControl/BudgetRequestListToolbarCanalDireto";
import BudgetFormContextProvider from "../context/BudgetFormContext";
import useFilter from "../hooks/useFilter";
import useFilterCanalDireto from "../hooks/useFilterCanalDireto";
import { getCallStatusStateOptions } from "../services/callCenterService";

const BudgetRequestControlScreen = ({requestType}) => {

    const _ = require("lodash");
    const [isForm, setIsForm] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
    const [actionButton, setActionButton] = useState({
      id: 1,
      text: "Adicionar Produto",
    });
    const [textosearch, setTextosearch] = useState("");
    const [quantityFiltered, setQuantityFiltered] = useState(0);
    const { filter, changeFilter } = useFilter();
    const { filterCanalDireto, changeFilterCanalDireto } = useFilterCanalDireto();

    const [statusStateOptions, setStatusStateOptions] = useState([])

    const fetchOptions = async () => {
        const options = await getCallStatusStateOptions();
        setStatusStateOptions(options);
    };

    useEffect(() => {
        fetchOptions()
    }, [])

    var [budgets, setProducts] = useState(products_mocs);
    var [productsFiltered, setProductsFiltered] = useState(products_mocs);

    const searchProducts = useCallback(() => {
      let list = _.filter(budgets, (o) => {
        return _.lowerCase(o.name).includes(_.lowerCase(textosearch));
      });
      setProductsFiltered(list);
    }, [_, budgets, textosearch]);

    useEffect(() => {
      searchProducts();
    }, [searchProducts, textosearch]);

    useEffect(() => {
      if(isForm !== requestType && isForm){
        setIsForm(false)
      }
    }, [requestType])

  return (
    <>
      <Helmet>
        <title>Controle Solicitação Orçamento</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        {isForm ? (
          <Container maxWidth={false}>
            <BudgetFormContextProvider setIsForm={setIsForm} isForm={isForm}>
              <BudgetForm />
            </BudgetFormContextProvider>
          </Container>
        ) : (
          <Container maxWidth={false}>
            {requestType === "canalAgente" ?
              <BudgetRequestListToolbarCanalDireto
                budgets={productsFiltered}
                setProducts={setProducts}
                setProductsFiltered={setProductsFiltered}
                isForm={isForm}
                setIsForm={setIsForm}
                isFilter={isFilter}
                setIsFilter={setIsFilter}
                quantityFiltered={quantityFiltered}
                actionButton={actionButton}
                setActionButton={setActionButton}
                selectedCustomerIds={selectedCustomerIds}
                setSelectedCustomerIds={setSelectedCustomerIds}
                statusStateOptions={statusStateOptions}
                textosearch={textosearch}
                setTextosearch={setTextosearch}
                changeFilter={changeFilterCanalDireto}
              />
              :
              <BudgetRequestListToolbar
                budgets={productsFiltered}
                setProducts={setProducts}
                setProductsFiltered={setProductsFiltered}
                isForm={isForm}
                setIsForm={setIsForm}
                isFilter={isFilter}
                setIsFilter={setIsFilter}
                quantityFiltered={quantityFiltered}
                actionButton={actionButton}
                setActionButton={setActionButton}
                selectedCustomerIds={selectedCustomerIds}
                setSelectedCustomerIds={setSelectedCustomerIds}
                statusStateOptions={statusStateOptions}
                textosearch={textosearch}
                setTextosearch={setTextosearch}
                changeFilter={changeFilter}
              />
            }
            <Box sx={{ pt: 3 }}>
              {requestType === "canalAgente" ?
                  <BudgetRequestListCanalDireto 
                      budgets={productsFiltered}
                      selectedCustomerIds={selectedCustomerIds}
                      setSelectedCustomerIds={setSelectedCustomerIds}
                      isFilter={isFilter}
                      setIsFilter={setIsFilter}
                      setQuantityFiltered={setQuantityFiltered}
                      filter={filterCanalDireto}
                      changeFilter={changeFilterCanalDireto}
                  /> 
                  :    
                  <BudgetRequestList 
                      budgets={productsFiltered}
                      selectedCustomerIds={selectedCustomerIds}
                      setSelectedCustomerIds={setSelectedCustomerIds}
                      isFilter={isFilter}
                      setIsFilter={setIsFilter}
                      setQuantityFiltered={setQuantityFiltered}
                      filter={filter}
                      changeFilter={changeFilter}
                  />
                }
            </Box>
          </Container>
          )}
      </Box>
    </>
  );
};

export default BudgetRequestControlScreen;
